
export default {
  props: ['blok']
}
